import { ClassRequestModel, SubjectClassReqModel } from "@boi/shared-models";
import { Injectable } from "@nestjs/common";
import { Brackets, DataSource, Repository } from "typeorm";
import { LanguageEntity } from "../../entities/language";
import { Subject } from "../../entities/subject";

@Injectable()
export class SubjectRepo extends Repository<Subject> {
    constructor(private dataSource: DataSource) {
        super(Subject, dataSource.createEntityManager());
    }

    async getSubjectsByClass(req: ClassRequestModel) {
        const subjectData = this.createQueryBuilder('s')
            .select(`s.id ,concat(s.subject,'-',language.language) as subject,s.language`)//qpm.tagline
            .leftJoin(LanguageEntity, 'language', 'language.id=s.language')
            // .leftJoin(QuestionPaperModal,'qpm', 'qpm.subject= s.id')
            .where(`s.class = '${req.classId}'`)
            .orderBy(`s.subject`)
        // .groupBy(`qpm.subject`)
        const data = await subjectData.getRawMany();
        return data;
    }
    async getLanguagesByClassSubject(subjectName: string, classId: number) {
        const subjectData = this.createQueryBuilder('s')
            .select('language.id ,language.language')
            .leftJoin(LanguageEntity, 'language', 'language.id=s.language')
            .where(`s.class = '${classId}' and UPPER(s.subject)='${subjectName.toLocaleUpperCase()}'`)
        const data = await subjectData.getRawMany();
        return data;
    }
    async getModelPaperDataBySubject(req: SubjectClassReqModel) {
        const modelPaperData = this.createQueryBuilder('qpm')
            .select(`qpm.instructions,qpm.no_of_sections AS noOfSections,qpm.marks,qpm.total_questions AS noOfQuestions,qpm.time_limit AS totalTime,qpm.tagline,qpm.part_name AS partName`)
            .where(`qpm.class = '${req.classId}' and qpm.subject = '${req.subject}'`)
        const data = await modelPaperData.getRawMany();
        return data
    }

    async getOtherLanguageSubjectIds(subjectName: string, classId: number, subjectId: number) {
        const subjectData = this.createQueryBuilder('s')
            .select('s.id as subjectId,language.id as languageId,language.language')
            .leftJoin(LanguageEntity, 'language', 'language.id=s.language')
            .where(`s.class = '${classId}' and UPPER(s.subject)='${subjectName.toLocaleUpperCase()}' and s.id!='${subjectId}'`)
        const data = await subjectData.getRawMany();
        return data;
    }

    async getAllSubjectIdsForPreview(subjectName: string, classId: number, subjectId: number) {
        const subjectData = this.createQueryBuilder('s')
            .select('s.id as subjectId,language.id as languageId,language.language')
            .leftJoin(LanguageEntity, 'language', 'language.id=s.language')
            .where(`s.class = '${classId}' and UPPER(s.subject)='${subjectName.toLocaleUpperCase()}'`)
        const data = await subjectData.getRawMany();
        return data;
    }

    async getSubjectsByClassId(req: ClassRequestModel) {
        const subjectData = this.createQueryBuilder('s')
            .select(`s.id ,s.subject`)
            .where(`s.class = '${req.classId}'`)
            .groupBy(`s.subject`)
        const data = await subjectData.getRawMany();
        return data;
    }

    async getBaseSubjectsDropDown(req: ClassRequestModel) {
        const results = await this.createQueryBuilder('subject')
            .select(`subject.id ,subject.subject,subject.language`)
            .where(qb => {
                const subQuery = qb.subQuery()
                    .select("DISTINCT s.subject_parent_id")
                    .from(Subject, "s")
                    .where("s.class = :class", { class: req.classId })
                    .getQuery();
                return "subject.id IN " + subQuery;
            })
            .getRawMany();

        console.log(results);
        return results;

    }

    // async getSubjectByClass(classId: number) {
    //     const qb = this.createQueryBuilder('s')
    //         .select(['s.subject', 's.id'])
    //         .where('s.subject IS NOT NULL')
    //         // .andWhere('s.language = :language', { language: 2 })
    //         .andWhere('s.language IN (:...languages)', { languages: [2, 5, 4] })
    //         .andWhere('s.class = :classId', { classId });

    //     const result = await qb.getRawMany();
    //     return result.map(row => ({
    //         id: row.s_id,
    //         subject: row.s_subject
    //     }));
    // }



    async getSubjectByClass(classId: number) {
        const specialLanguages = [1, 3]; // Telugu, Urdu
        const normalLanguages = [2, 5, 4]; // Other languages
        const qb = this.createQueryBuilder('s')
            .select(['s.subject', 's.id'])
            .where('s.subject IS NOT NULL')
            .andWhere('s.class = :classId', { classId })
            .andWhere(
                new Brackets((qb1) => {
                    qb1.where('s.language IN (:...languages)', { languages: normalLanguages });
                    qb1.orWhere(
                        new Brackets((qb2) => {
                            qb2.where('s.language IN (:...specialLanguages)', { specialLanguages })
                                .andWhere(
                                    new Brackets((qb3) => {
                                        qb3.where(`UPPER(s.subject) LIKE :telugu`, { telugu: '%TELUGU%' })
                                            .orWhere(`UPPER(s.subject) LIKE :urdu`, { urdu: '%URDU%' });
                                    }),
                                );
                        }),
                    );
                }),
            );
        const result = await qb.getRawMany();
        return result.map((row) => ({
            id: row.s_id,
            subject: row.s_subject,
        }));
    }

    // async getSubjectByClass(classId: number) {
    //     const specialLanguages = [1, 3]; // Telugu and Urdu Only
    //     const normalLanguages = [2, 5, 4]; // Remaining
    //     const qb = this.createQueryBuilder('s')
    //         .select(['s.subject', 's.id'])
    //         .where('s.subject IS NOT NULL')
    //         .andWhere('s.class = :classId', { classId })
    //         .andWhere(
    //             new Brackets((qb1) => {
    //                 qb1.where('s.language IN (:...languages)', { languages: normalLanguages });
    //                 qb1.orWhere(
    //                     new Brackets((qb2) => {
    //                         qb2.where('s.language IN (:...specialLanguages)', { specialLanguages })
    //                             .andWhere(
    //                                 `s.subject LIKE ('Telugu', 'Urdu')`
    //                             );
    //                     }),
    //                 );
    //             }),
    //         );
    //     const result = await qb.getRawMany();
    //     return result.map((row) => ({
    //         id: row.s_id,
    //         subject: row.s_subject,
    //     }));
    // }


    async getDistinctSubjectsRepo() {
        const data = await this.createQueryBuilder('s')
            .select(['s.id', 's.subject'])
            .groupBy('s.subject')
            .getRawMany();
        return data;
    }

}